import { render } from "./MinhasVendas.vue?vue&type=template&id=a478ae4a"
import script from "./MinhasVendas.vue?vue&type=script&lang=js"
export * from "./MinhasVendas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__